export const langs = [
  {
    code: 'ar',
    name: 'العربية',
    dir: 'rtl',
  },
  {
    code: 'zh',
    name: '中文',
    dir: 'ltr',
  },
  {
    code: 'en',
    name: 'English',
    dir: 'ltr',
  },
  {
    code: 'fr',
    name: 'Français',
    dir: 'ltr',
  },
  {
    code: 'ru',
    name: 'Русский',
    dir: 'ltr',
  },
  {
    code: 'es',
    name: 'Español',
    dir: 'ltr',
  },
];
